import React from 'react'
import { useTranslation } from 'react-i18next'

const GenericResultModal = ({ gameResult }) => {
  const {t} = useTranslation()
  return (
    <div className='verify-result-border-container'>
      <div className='verify-result-slider-box'>
        {gameResult
          ? (
            <div className='slider-box text-center'>
              <span style={{ color: '#fff' }}>
                {gameResult} x
              </span>
            </div>)
          : (
            <div className='text-center'>
              <span style={{ color: '#fff' }}>
                {t('CORRECT_INPUT_RESULT')}
              </span>
            </div>)}
      </div>
    </div>

  )
}

export default GenericResultModal
